import { useState } from 'react';
import styled from 'styled-components';
import { Column } from 'styled/alignment/Column';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';
import { Phone } from 'react-feather';
import Text from 'components/_UI/Text';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { FullyCentered } from 'styled/alignment/Center';
import { Row } from 'styled/alignment/Row';
import DynamicProfileImage from 'components/commons/DynamicProfileImage';
import paths from 'routes/paths';

export default function Sectors({ sectors, event }) {
  
  const extendedSectors = [
    {
      id: 'all',
      name: 'Todos'
    },
    ...sectors
  ]

  const [sectorNames, setSectorNames] = useState(extendedSectors.map(sector => {
    return {
      value: sector.id,
      label: sector.name
    }
  }))

  const [sectorEstablishments, setSectorEstablishments] = useState(sectors.flatMap(sector => sector.establishments))

  const onSelectSector = (selectedSector) => {
    if (selectedSector.value === 'all') {
      setSectorEstablishments(sectors.flatMap(sector => sector.establishments))

      return
    }

    const index = sectors.findIndex(sector => sector.id === selectedSector.value)
    setSectorEstablishments(sectors[index].establishments)
  }

  return (
    <Container>
      <Content>
        <StoresHeader>
          <Text
            name='title'
            color={colors.occasionalPurple}
            marginBottom={0}
            paddingBottom={0}
          >
            Lojas
          </Text>
          <StoresControls>
            <Select
              placeholder='Setores'
              defaultValue={sectorNames[0]}
              options={sectorNames}
              onChange={onSelectSector}
            >
            </Select>
          </StoresControls>
        </StoresHeader>

        <StoresGrid>
          {!!sectorEstablishments && sectorEstablishments.map((store, index) => (
            <StoreCard
              key={store.id}
              to={paths.events.establishment(event?.slug, store?.slug)}
            >
              
              <StoreHeader>
                <StoreImageContainer>
                  {/* <StoreImage src={store.profile_image} alt={store.name} width={64} height={64} /> */}
                  <DynamicProfileImage
                    img={store.profile_image}
                    alt={store.name}
                    word={store.name}
                    size={'54px'}
                  />
                </StoreImageContainer>

                <StoreInfo>
                  <StoreName>{store.name}</StoreName>

                  <Text color={colors.night} marginTop={'-4px'}>
                    {store?.sector_data?.name}
                    
                  </Text>

                  <CategoriesContainer>
                    {/* <Category >
                      <Text name='mini' color={colors.neutral} paddingBottom={0} >
                        {store?.sector_data?.name}
                      </Text>
                    </Category> */}

                    {
                      store?.tags?.map((tag) => (
                        <Category type='tag' key={tag}>
                          <Text name='mini' color={colors.neutral} paddingBottom={0} >
                            {tag?.name}
                          </Text>
                        </Category>

                      ))
                    }
                  </CategoriesContainer>

                </StoreInfo>
              </StoreHeader>
            </StoreCard>

          ))}
        </StoresGrid>
      </Content>
    </Container>
  );
}

const Container = styled(Column)`
    width: 100%;
    padding: 4%;
    margin-bottom: 30px;
    
    @media screen and (min-width: ${breakpoints.lg}) {
      padding: 1%;
    }
`;

const Content = styled(Column)`
    width: 100%;
    padding: 30px;
    background-color: ${colors.neutralLight};
    box-shadow: 0 0 4px #ccc;
    border-radius: 8px;
    border: 1px solid ${colors.neutralDark};
    gap: 1rem;
    max-height: 800px;
    overflow-y: scroll;
`;

const StoresHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  gap: .5rem;

  @media screen and (min-width: ${breakpoints.sm}) {
    flex-direction: row;
  }
`

const StoresControls = styled.div`
  @media screen and (min-width: ${breakpoints.sm}) {
    width: 250px;
  }
`

const StoresGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 1.5rem;
  
  @media screen and (min-width: ${breakpoints.sm}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  
  @media screen and (min-width: ${breakpoints.md}) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  
  @media screen and (min-width: ${breakpoints.lg}) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  `

const StoreCard = styled(Link)`
  padding: 20px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: rgb(204, 204, 204) 0px 0px 3px;
  border: 1px solid ${colors.neutralDark};
  position: relative;

  &:hover {
    transform: scale(1.02);
  }
`

const StoreHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
`

const StoreImageContainer = styled.div`
  position: relative;
  width: 64px;
  height: 64px;
`

const StoreImage = styled.img`
  max-width: 64px;
  max-height: 64px;
  border-radius: 0.75rem;
  object-fit: cover;
`

const StoreInfo = styled.div`
  flex: 1;
  min-width: 0;
`

const StoreName = styled.h3`
  font-weight: 700;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.3s ease;
  margin-bottom: 8px;

  /* ${StoreCard}:hover & {
    color: ${colors.occasionalPurple};
  } */
`

const Category = styled(FullyCentered)`
  color: ${colors.night};
  background-color: ${colors.occasionalPurple};
  border-radius: 30px;
  width: auto;
  padding: 4px 6px;
  margin-top: 4px;
  margin-right: 6px;
  
  ${({ type }) => type === 'tag' && `
    background-color: ${colors.occasionalOrange};
  `}

  & > p {
    width: auto;
    text-transform: capitalize;
  }
`
const CategoriesContainer = styled(Row)`
  flex-wrap: wrap;
`;